import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Circle } from '../circles-page/types';
import type { CircleCreateState } from './types';

const initialState: CircleCreateState = {
  loading: false,
  error: null,
  success: false,
  circle: null
};

export const slice = createSlice({
  name: 'circleCreate',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    createCircleSuccess: (state, action: PayloadAction<Circle>) => {
      state.loading = false;
      state.success = true;
      state.circle = action.payload;
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
      state.success = false;
    },
    reset: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.circle = null;
    }
  }
});

export default slice.reducer;
